import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../context/authContext";
import { useToastOnLoad } from "../../Hooks/useToastOnLoad";
import Logo from "../../Imagens/logoPentagov.jpg";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";

const Index = () => {
  const navigate = useNavigate();
  useToastOnLoad();
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const { login } = useAuthContext();

  const handleLogin = async () => {
    const result = await login(usuario, password);
    if (result.success) {
      navigate("/Menu");
    } else {
      console.log("Erro", result.message || "Erro ao fazer login", "error");
      const msgEl = document.getElementById("msm_senha");
      if (msgEl) {
        msgEl.innerText = "Usuário e senha não conferem!";
        msgEl.style.display = "block";
      }
    }
  };

  return (
    <div className="TelaLoginInicial" align="center">
      <div className="PainelLogin">
        <div className="login-container p-4 shadow">
          <div id="painelLOGO">
            <img style={{ width: "100%", borderRadius: "10px" }} src={Logo} alt="Logo PentaGOV" />
          </div>
          <form style={{ paddingTop: "30px" }}>
            <div className="form-group mb-3" align="left">
              <input
                type="text"
                className="form-control form-control-lg"
                placeholder="Email"
                value={usuario}
                onChange={(e) => setUsuario(e.target.value)}
              />
            </div>
            <div className="form-group mb-4" align="left" style={{ position: "relative" }}>
              <input
                type={passwordVisible ? "text" : "password"}
                className="form-control form-control-lg"
                placeholder="Senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleLogin();
                }}
                style={{ paddingRight: "3rem" }}
              />
              <span
                onClick={() => setPasswordVisible((prev) => !prev)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#666",
                }}
              >
                {passwordVisible ? <i className="fas fa-eye-slash" /> : <i className="fas fa-eye" />}
              </span>
            </div>
            <button type="button" className="btn btn-primary btn-lg w-100" onClick={handleLogin}>
              ENTRAR
            </button>
            <label id="msm_senha" style={{ display: "none", color: "red", marginTop: "10px" }}></label>
            <div className="mt-3 text-center">
              <button
                type="button"
                className="link-recuperar"
                onClick={() => navigate("/recuperar-senha")}
              >
                Esqueci minha senha
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Index;
